export const uk = {
    'exclude-phrases': 'Исключить фразы с нулевыми показами'
};
